﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aAvstand?: Valg<string>;
    bReisetid?: Valg<string>;
    visAvstand: boolean;
    visVilkar: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_AVSTAND = 'TOGGLE_AVSTAND';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleAvstandAction {
    type: typeof TOGGLE_AVSTAND;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export type ValgStateActionTypes = UpdateValgAction | ToggleAvstandAction | ToggleVilkarAction;
